import { PHONE_REGEX } from '@/utils/regex.utils';
import { z } from 'zod';
import { companySchema } from '../company/company.schema';
import { userEntityRoleSchema } from '../user-entity-role/user-entity-role.schema';
import i18next from 'i18next';

export const branchSchema = z.object({
  id: z.string().optional(),
  companyId: z.string().nullish(),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:branchNameRequired'),
      });
    }
  }),
  addressLine1: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:addressLine1Required'),
      });
    }
  }),
  addressLine2: z.string().nullish(),
  state: z.string().nullish(),
  postalCode: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:postalCodeRequired'),
      });
    }
  }),
  city: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:cityRequired'),
      });
    }
  }),
  country: z.string().nullish(),
  logo: z.string().nullish(),
  primaryPhone: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:primaryPhoneNumberRequired'),
      });
    } else if (!PHONE_REGEX.test(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:phoneNumberIncorrect'),
      });
    }
  }),
  secondaryPhone: z.string().superRefine((data, ctx) => {
    if (data && !PHONE_REGEX.test(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:phoneNumberIncorrect'),
      });
    }
  }),
  email: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailRequired'),
      });
    } else if (!z.string().email().safeParse(data).success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailInvalidFormat'),
      });
    }
  }),
  active: z.boolean().default(true),
  company: z.lazy(() => companySchema).nullish(),
  entityRoles: z.array(userEntityRoleSchema).nullish(),
  partFolderNotFound: z.string().nullish(),
  partContactUs: z.string().nullish(),
  proContactUs: z.string().nullish(),
});

export type TBranchSchema = z.infer<typeof branchSchema>;
